import { UserDataDTO } from 'iam/dtos/user-data'
import { Model } from 'infra/model'
import { makeObservable, observable } from 'mobx'
import { Id } from 'types/definitions'
import { UserDataType } from './UserDataType'
import { match } from '../../utils/pattern-match-util'
import { ProviderActivePtinStatusDto } from './ProviderActivePtinStatusDto'

export default class UserData extends Model<UserDataDTO, UserData> {
  @observable userPublicId = Id.none
  @observable userDataType = UserDataType.User
  @observable givenName = ''
  @observable familyName = ''
  @observable email = ''
  @observable phone = ''
  @observable workspaceSlugs: string[] = []
  @observable jobCapacity = 0
  @observable ptinStatus = ProviderActivePtinStatusDto.NotApplicable

  constructor() {
    super()

    makeObservable(this)
  }

  parse(json: Partial<UserDataDTO>): Partial<UserData> {
    return {
      userPublicId: json.user_public_id,
      userDataType:
        json.type &&
        match(json.type, {
          USER: () => UserDataType.User,
          PRO: () => UserDataType.Pro,
          ADMIN: () => UserDataType.Admin,
          [match.DEFAULT]: () => UserDataType.User,
        }),
      ptinStatus:
        json.active_ptin &&
        match(json.active_ptin, {
          NOT_APPLICABLE: () => ProviderActivePtinStatusDto.NotApplicable,
          ACTIVE: () => ProviderActivePtinStatusDto.Active,
          INACTIVE: () => ProviderActivePtinStatusDto.Inactive,
          [match.DEFAULT]: () => ProviderActivePtinStatusDto.NotApplicable,
        }),
      givenName: json.given_name,
      familyName: json.family_name,
      email: json.email,
      phone: json.phone,
      workspaceSlugs: json.workspace_slugs,
      jobCapacity: json.job_capacity,
    }
  }
}
